import { render, staticRenderFns } from "./edit.schedule-items.page.vue?vue&type=template&id=3f547fd5&"
import script from "./edit.schedule-items.page.vue?vue&type=script&lang=js&"
export * from "./edit.schedule-items.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports